<template>
    <Section width="lg">
        <div class="container">
            <h1 class="white section--header loading">{{ $store.state.settings.redirect_page_string }}</h1>
        </div>
        <div class="container">
            <PrismicImage :img="$store.state.settings.redirect_page_image" />
        </div>
    </Section>
</template>
<script>
import getDocument from '@/plugins/get-document.js';
export default {
    async middleware({ store, $prismic }) {
        await store.dispatch('fetchStates', $prismic);
    },
    async asyncData({$prismic, route, error}) {
        try {
            return await getDocument($prismic, route.path, error, 'out');
        }
        catch (e) {
            error({statusCode: 404, message: 'Not found'});
        }
    },
    head() {
        return {
            title: this.$store.state.settings.redirect_page_string,
            meta: [
                // no index affiliate links for sea reasons
                { name: 'robots', content: 'noindex' }
            ]
        };
    },
    mounted() {
        window.location.assign(this.$tracking.addTrackingParameters(this.document.data.redirect, this.$route.query));
    }
};
</script>

<style lang="scss" scoped>
    section::v-deep {
        background: $pink;
        height: 100vh;
        box-sizing: border-box;

        .section-inner {
            @include grid(1, 40px);

            @include device(pad) {
                @include grid(2, 80px);
            }

            .container {
                @include flex;

                .loading:after {
                  content: ' .';
                  animation: dots 1.5s steps(5, end) infinite;
              }

              @keyframes dots {
                  0%, 20% {
                      color: rgba(0,0,0,0);
                      text-shadow:
                      .25em 0 0 rgba(0,0,0,0),
                      .5em 0 0 rgba(0,0,0,0);}
                      40% {
                          color: white;
                          text-shadow:
                          .25em 0 0 rgba(0,0,0,0),
                          .5em 0 0 rgba(0,0,0,0);}
                          60% {
                              text-shadow:
                              .25em 0 0 white,
                              .5em 0 0 rgba(0,0,0,0);}
                              80%, 100% {
                                  text-shadow:
                                  .25em 0 0 white,
                                  .5em 0 0 white;}
                              }
            }
        }
    }
</style>